import React, { useContext, useEffect } from 'react';
import { AppSettings } from './../../config/app-settings.js';

function ExtraMessengerPage() {
	const context = useContext(AppSettings);

	useEffect(() => {
		context.handleSetAppSidebarMinified(true);
		context.handleSetAppHeaderInverse(true);
		context.handleSetAppContentFullHeight(true);
		context.handleSetAppContentClass('p-0 bg-component');

		const chatToggles = [...document.querySelectorAll('[data-toggle-class="messenger-chat-content-mobile-toggled"]')];
		const handleChatToggle = (event) => {
			event.preventDefault();
			document.querySelector('#messenger')?.classList.toggle('messenger-chat-content-mobile-toggled');
		};
		chatToggles.forEach((toggle) => toggle.addEventListener('click', handleChatToggle));

		return () => {
			chatToggles.forEach((toggle) => toggle.removeEventListener('click', handleChatToggle));
			context.handleSetAppSidebarMinified(false);
			context.handleSetAppHeaderInverse(false);
			context.handleSetAppContentFullHeight(false);
			context.handleSetAppContentClass('');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<div className="messenger" id="messenger">
							<div className="messenger-menu">
								<div className="messenger-menu-item my-2">
									<a href="#/" className="messenger-menu-link">
										<div className="m-n1">
											<img alt="" src="/color-admin/admin/react/assets/img/user/user-13.jpg" className="w-100 d-block rounded-circle" />
										</div>
									</a>
								</div>
								<div className="messenger-menu-item active">
									<a href="#/" className="messenger-menu-link">
										<iconify-icon className="fs-30px" icon="solar:dialog-2-bold-duotone"></iconify-icon>
									</a>
								</div>
								<div className="messenger-menu-item">
									<a href="#/" className="messenger-menu-link">
										<iconify-icon className="fs-30px" icon="solar:notebook-bold-duotone"></iconify-icon>
									</a>
								</div>
								<div className="messenger-menu-item">
									<a href="#/" className="messenger-menu-link">
										<iconify-icon className="fs-30px" icon="solar:box-minimalistic-bold-duotone"></iconify-icon>
									</a>
								</div>
								<div className="messenger-menu-item">
									<a href="#/" className="messenger-menu-link">
										<iconify-icon className="fs-30px" icon="solar:folder-with-files-bold-duotone"></iconify-icon>
									</a>
								</div>
								<div className="messenger-menu-item">
									<a href="#/" className="messenger-menu-link">
										<iconify-icon className="fs-30px" icon="solar:clapperboard-play-bold-duotone"></iconify-icon>
									</a>
								</div>
								<div className="messenger-menu-item">
									<a href="#/" className="messenger-menu-link">
										<iconify-icon className="fs-30px" icon="solar:settings-bold-duotone"></iconify-icon>
									</a>
								</div>
							</div>
							<div className="messenger-chat">
								<div className="messenger-chat-header d-flex">
									<div className="flex-1 position-relative">
										<input type="text" className="form-control ps-30px" placeholder="Search" />
										<div className="w-35px h-100 position-absolute start-0 top-0 d-flex align-items-center justify-content-center">
											<iconify-icon icon="octicon:search-16" className="fs-5"></iconify-icon>
										</div>
									</div>
									<div className="ps-2">
										<a href="#/" className="btn btn-default shadow-none">
											<i className="fa fa-plus"></i>
										</a>
									</div>
								</div>
								<div className="messenger-chat-body">
									<div data-scrollbar="true" data-height="100%">
										<div className="messenger-chat-list">
											<div className="messenger-chat-item">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media">
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-1.jpg" />
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Daniel</div>
															<div className="messenger-chat-time">09:15 AM</div>
														</div>
														<div className="messenger-chat-desc"> Hey, how was your weekend?</div>
													</div>
												</a>
											</div>
											<div className="messenger-chat-item active">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media flex-wrap overflow-hidden">
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-1.jpg" width="14" className="rounded-0 me-1px mb-1px" />
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-2.jpg" width="14" className="rounded-0 me-1px mb-1px" />
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-3.jpg" width="14" className="rounded-0 me-0px mb-1px" />
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-4.jpg" width="14" className="rounded-0 me-1px mb-1px" />
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-5.jpg" width="14" className="rounded-0 me-1px mb-1px" />
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-6.jpg" width="14" className="rounded-0 me-0px mb-1px" />
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-7.jpg" width="14" className="rounded-0 me-1px mb-1px" />
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-8.jpg" width="14" className="rounded-0 me-1px mb-1px" />
														<img alt="" src="/color-admin/admin/react/assets/img/user/user-9.jpg" width="14" className="rounded-0 me-0px mb-1px" />
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Company Discussion Group (9)</div>
															<div className="messenger-chat-time">10:30 AM</div>
														</div>
														<div className="messenger-chat-desc">Me: We need to prepare the project report by Friday. </div>
													</div>
												</a>
											</div>
											<div className="messenger-chat-item">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media bg-lime-900 text-lime">
														<iconify-icon icon="solar:book-bold-duotone"></iconify-icon>
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Online Course (12)</div>
															<div className="messenger-chat-time">11:45 AM</div>
														</div>
														<div className="messenger-chat-desc">Emily: Let's meet at the library at 1 PM to study. </div>
													</div>
												</a>
											</div>
											<div className="messenger-chat-item">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media bg-orange text-orange-900">
														<iconify-icon icon="solar:oven-mitts-bold-duotone"></iconify-icon>
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Pizza Lovers</div>
															<div className="messenger-chat-time">12:20 PM</div>
														</div>
														<div className="messenger-chat-desc"> I found a new pizzeria for our next meetup! </div>
													</div>
												</a>
											</div>
											<div className="messenger-chat-item">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media bg-blue-900 text-blue">
														<iconify-icon icon="solar:gamepad-charge-bold-duotone"></iconify-icon>
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Gaming Crew</div>
															<div className="messenger-chat-time">01:05 PM</div>
														</div>
														<div className="messenger-chat-desc"> Anyone up for a game of Among Us tonight? </div>
													</div>
												</a>
											</div>
											<div className="messenger-chat-item">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media row gx-0 overflow-hidden">
														<div className="col-6 d-flex flex-column">
															<img alt="" src="/color-admin/admin/react/assets/img/user/user-10.jpg" className="w-100 rounded-0" />
															<img alt="" src="/color-admin/admin/react/assets/img/user/user-11.jpg" className="w-100 rounded-0" />
														</div>
														<div className="col-6 d-flex flex-column">
															<img alt="" src="/color-admin/admin/react/assets/img/user/user-12.jpg" className="w-100 rounded-0" />
															<img alt="" src="/color-admin/admin/react/assets/img/user/user-13.jpg" className="w-100 rounded-0" />
														</div>
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Weekend Plans</div>
															<div className="messenger-chat-time">02:15 PM</div>
														</div>
														<div className="messenger-chat-desc"> How about a hike this Saturday morning? </div>
													</div>
												</a>
											</div>
											<div className="messenger-chat-item">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media">
														<iconify-icon className="text-red-600" icon="solar:calendar-bold-duotone"></iconify-icon>
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Event Reminders</div>
															<div className="messenger-chat-time">03:00 PM</div>
														</div>
														<div className="messenger-chat-desc"> Don't forget Grandma's birthday tomorrow! </div>
													</div>
												</a>
											</div>
											<div className="messenger-chat-item">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media">
														<iconify-icon icon="solar:clipboard-list-bold-duotone"></iconify-icon>
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Party Planning</div>
															<div className="messenger-chat-time">03:45 PM</div>
														</div>
														<div className="messenger-chat-desc"> We need to finalize the decorations for the party. </div>
													</div>
												</a>
											</div>
											<div className="messenger-chat-item">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media">
														<iconify-icon icon="solar:book-bold-duotone"></iconify-icon>
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Book Club Discussions</div>
															<div className="messenger-chat-time">04:30 PM</div>
														</div>
														<div className="messenger-chat-desc"> What did you think of the last book's ending? </div>
													</div>
												</a>
											</div>
											<div className="messenger-chat-item">
												<a href="#/" className="messenger-chat-link" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
													<div className="messenger-chat-media">
														<iconify-icon icon="solar:bicycling-bold-duotone"></iconify-icon>
													</div>
													<div className="messenger-chat-content">
														<div className="messenger-chat-title">
															<div>Road Trip Ideas</div>
															<div className="messenger-chat-time">05:15 PM</div>
														</div>
														<div className="messenger-chat-desc"> Let's plan our road trip route and stops! </div>
													</div>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="messenger-content">
								
								<div className="messenger-content-header">
									<div className="d-block d-lg-none">
										<button type="button" className="btn border-transparent shadow-none ps-0" data-toggle-class="messenger-chat-content-mobile-toggled" data-toggle-target="#messenger">
											<i className="fa fa-chevron-left fa-lg"></i>
										</button>
									</div>
									<div className="flex-1">
										<div className="fs-5 fw-bold">Company Discussion Group (9)</div>
									</div>
									<div className="">
										<button type="button" className="btn border-transparent shadow-none pe-0" data-bs-toggle="dropdown">
											<i className="fa fa-ellipsis fa-lg"></i>
										</button>
										<ul className="dropdown-menu">
											<li>
												<a className="dropdown-item" href="#/">Action</a>
											</li>
											<li>
												<a className="dropdown-item" href="#/">Another action</a>
											</li>
											<li>
												<a className="dropdown-item" href="#/">Something else here</a>
											</li>
										</ul>
									</div>
								</div>
								
								
								
								<div className="messenger-content-body p-0">
									<div className="widget-chat p-3" data-scrollbar="true" data-height="100%">
										<div className="widget-chat-date">Today 08:10AM</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-content">
												<div className="widget-chat-message last"> Good morning, team! Just a reminder, we need to prepare the project report by Friday. Let's stay on track and meet our deadlines. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 09:02AM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-1.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-blue">Daniel</div>
												<div className="widget-chat-message last">Morning! I'm on it and will start compiling the data today. </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-2.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-indigo">Mark</div>
												<div className="widget-chat-message last">Thanks for the heads up! I'll make sure the design elements are ready for the report. </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-3.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-red">Alexander</div>
												<div className="widget-chat-message last">Got it. I'll review the financial data and ensure all the numbers are accurate. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 10:10AM</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-13.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-message last">Great! Let's have a progress check-in at 2 PM today to see how things are going. Keep up the good work, team! </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-1.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-blue">Daniel</div>
												<div className="widget-chat-message last"> Sounds good! See you at the meeting. </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-2.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-indigo">Mark</div>
												<div className="widget-chat-message last">Looking forward to it. We'll have everything ready. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 11:15AM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-3.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-red">Alexander</div>
												<div className="widget-chat-message last">Count me in. I'll be prepared with the financial figures. </div>
											</div>
										</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-13.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-orange"></div>
												<div className="widget-chat-message last">Excellent teamwork, everyone! We're making great progress. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 12:20PM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-1.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-blue">Daniel</div>
												<div className="widget-chat-message last">Thank you! It's a team effort. </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-2.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-indigo">Mark</div>
												<div className="widget-chat-message last">Absolutely, we've got a strong team. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 02:00PM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-3.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-red">Alexander</div>
												<div className="widget-chat-message last">Agreed, we're all working towards the same goal. </div>
											</div>
										</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-13.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-message last">That's the spirit! Let's keep the communication flowing. If you have any questions or face any challenges, don't hesitate to reach out. </div>
												<div className="widget-chat-status"><b>Read</b> 02:45PM</div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-1.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-blue">Daniel</div>
												<div className="widget-chat-message last">Will do, Manager. </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-2.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-info-container">
													<div className="widget-chat-name text-indigo">Mark</div>
													<div className="widget-chat-message last">Understood, we'll collaborate closely. </div>
												</div>
											</div>
										</div>
										<div className="widget-chat-date">Today 04:00PM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-3.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-red">Alexander</div>
												<div className="widget-chat-message last">Thanks for the support, Manager. </div>
											</div>
										</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-13.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-message last">Alexander, can you also provide an update on the budget allocation? </div>
												<div className="widget-chat-status"><b>Read</b> 04:25PM</div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-3.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-red">Alexander</div>
												<div className="widget-chat-message last">Sure, I'll get that information for you by the end of the day. </div>
											</div>
										</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-content">
												<div className="widget-chat-message last">Perfect. And Mark, how's the visual design coming along? </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-2.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-indigo">Mark</div>
												<div className="widget-chat-message last">It's going smoothly. I'll share the mockups with you later today. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 06:12PM</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-13.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-message last">Sounds great, Mark. Looking forward to it. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 06:30PM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-1.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-blue">Daniel</div>
												<div className="widget-chat-message last">Should we discuss the presentation format for the report? </div>
											</div>
										</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-content">
												<div className="widget-chat-message last">Good point, Daniel. Let's have a quick discussion on that during the meeting today. </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-3.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-red">Alexander</div>
												<div className="widget-chat-message last">I'll make sure the financial data is presented in a clear and concise manner. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 07:50PM</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-content">
												<div className="widget-chat-message last">Thank you, Alexander. That will be essential for our stakeholders. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 08:15PM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-2.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-indigo">Mark</div>
												<div className="widget-chat-message last">Do we have all the necessary data and information for the report? </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-4.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-blue">Daniel</div>
												<div className="widget-chat-message last">I've collected most of it, but I'm waiting on a few figures from the sales team. </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 09:34PM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-3.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-red">Alexander</div>
												<div className="widget-chat-message last">I'll follow up with them to expedite the process. </div>
											</div>
										</div>
										<div className="widget-chat-item reply">
											<div className="widget-chat-content">
												<div className="widget-chat-message last">Great teamwork, everyone. Keep up the good work. Our client will be impressed! </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 09:55PM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-4.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-blue">Daniel</div>
												<div className="widget-chat-message last">We won't disappoint! </div>
											</div>
										</div>
										<div className="widget-chat-date">Today 10:20PM</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-2.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-indigo">Mark</div>
												<div className="widget-chat-message last">Let's make it a stellar report! </div>
											</div>
										</div>
										<div className="widget-chat-item">
											<div className="widget-chat-media">
												<img alt="" src="/color-admin/admin/react/assets/img/user/user-3.jpg" />
											</div>
											<div className="widget-chat-content">
												<div className="widget-chat-name text-red">Alexander</div>
												<div className="widget-chat-message last">Agreed, let's do our best! </div>
											</div>
										</div>
									</div>
								</div>
								
								
								
								<div className="messenger-content-input position-relative p-0 pb-5">
									<div className="d-flex align-items-center position-absolute bottom-0 start-0 p-3 pb-2 gap-3">
										<a href="#/" className="link-secondary text-decoration-none">
											<iconify-icon className="fs-26px" icon="solar:smile-circle-outline"></iconify-icon>
										</a>
										<a href="#/" className="link-secondary text-decoration-none">
											<iconify-icon className="fs-26px" icon="solar:folder-with-files-outline"></iconify-icon>
										</a>
										<a href="#/" className="link-secondary text-decoration-none">
											<iconify-icon className="fs-26px" icon="solar:scissors-square-outline"></iconify-icon>
										</a>
										<a href="#/" className="link-secondary text-decoration-none">
											<iconify-icon className="fs-26px" icon="solar:chat-round-dots-outline"></iconify-icon>
										</a>
										<a href="#/" className="link-secondary text-decoration-none">
											<iconify-icon className="fs-26px" icon="solar:phone-calling-outline"></iconify-icon>
										</a>
										<a href="#/" className="link-secondary text-decoration-none">
											<iconify-icon className="fs-26px" icon="solar:videocamera-record-outline"></iconify-icon>
										</a>
									</div>
									<textarea className="form-control p-3 border-0 shadow-none" rows="3" placeholder="Write a message..."></textarea>
								</div>
								
							</div>
						</div>
		</>
	);
}

export default ExtraMessengerPage;
